/* Collection-scoped, demand-driven availability ordering. No catalog writes. */
(() => {
  'use strict';
  if (window.swStockOrder || String(window.Shopify?.theme?.id)!=='186421346577'||!document.querySelector('[data-sw-order-release="v2"]')) return;
  const policy=window.SwCollectionOrderPolicy;
  const attr = 'data-limoniapps-discountninja-product-handle';
  const availableAttr = 'data-limoniapps-discountninja-product-available';
  const cache = new Map();
  let run = 0, controller;
  const state = window.swStockOrder = { version: 1, status: 'idle', metrics: {} };
  function keyFor(url) {
    const u = new URL(url); ['page', 'section_id', '_sw_stock','sw_loaded','sw_order_debug'].forEach(k => u.searchParams.delete(k));
    u.searchParams.sort(); return u.href;
  }
  async function get(url, signal) {
    const response = await fetch(url, {signal: AbortSignal.any([signal,AbortSignal.timeout(15000)]), credentials: 'same-origin'});
    if (!response.ok) throw Error('HTTP ' + response.status);
    return response.text();
  }
  function remember(key, entry) {
    if (cache.size >= 5 && !cache.has(key)) cache.delete(cache.keys().next().value);
    cache.set(key, entry);
    try { sessionStorage.setItem('sw-collection-stock-v2',JSON.stringify({key,entry})); } catch (_) { /* Optional cache. */ }
  }
  function cardsFrom(root, map) {
    root.querySelectorAll('.collection-products-grid > [' + attr + ']').forEach(n => map.set(n.getAttribute(attr), n.cloneNode(true)));
  }
  async function start() {
    const root = document.querySelector('[data-sw-stock]');
    if (!root) return;
    const grid = root.querySelector('.collection-products-grid');
    if (!grid) return;
    const token = ++run;
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal;
    const startTime = performance.now();
    const url = new URL(location.href), key = keyFor(url), size = Number(root.dataset.swSize);
    // Boost can finish an older facet request after a newer one. Never accept its
    // stale filter chips/counts or initial cards: restore the URL's current state.
    const queryNode=root.querySelector('[data-sw-stock-query]');
    if(queryNode) {
      const source=JSON.parse(queryNode.textContent);
      const normalize=pairs=>JSON.stringify(pairs.filter(Boolean).map(([k,v])=>[k,k.startsWith('filter.v.price.')?String(Number(v)):String(v)]).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b))));
      const requested=[...url.searchParams].filter(([k,v])=>k.startsWith('filter.')&&v!=='');
      if(source.sort!==(url.searchParams.get('sort_by')||source.defaultSort)||normalize(source.filters)!==normalize(requested)) {
        // A fresh server response may legitimately ignore an unsupported filter.
        // Restore at most once per URL, then use Shopify's canonical result.
        let restored=true;
        try {restored=sessionStorage.getItem('sw-stock-restored')===url.href;if(!restored)sessionStorage.setItem('sw-stock-restored',url.href);}catch(_) {/* Storage can be disabled. */}
        if(!restored){root.dataset.swState='loading';state.status='restoring';location.replace(url.href);return;}
      } else {
        try {sessionStorage.removeItem('sw-stock-restored');}catch(_) {}
      }
    }
    const feel = window.swSquishyCategory?.choice(root, url) || '';
    const page = Math.max(1, Number(url.searchParams.get('page')) || 1);
    const end = page * size, begin = end - size;
    const ctx=policy.context(root.dataset.swCollectionId,url);
    const sourceUrl=()=>policy.sourceUrl(key,ctx.cid);
    const initial = grid.innerHTML;
    root.dataset.swPolicy='v2';
    const nativePagination = root.querySelector('.pagination');
    const originalPaging = nativePagination?.outerHTML || '';
    root.querySelectorAll('.sw-stock-status,.sw-stock-paging').forEach(n => n.remove());
    const status = document.createElement('p'); status.className = 'sw-stock-status';
    status.setAttribute('role', 'status');status.setAttribute('aria-live','polite');status.setAttribute('style','width:fit-content;max-width:90%;margin:10px auto;padding:7px 13px;border-radius:18px;background:#fff3db;color:#5f1315;font-size:14px;line-height:1.5');status.textContent='רגע, מסדרים לכם את הטעים…';status.hidden=true;
    grid.before(status);grid.setAttribute('aria-busy','true');
    const statusTimer=window.setTimeout?window.setTimeout(()=>{if(token===run&&root.isConnected&&root.dataset.swState==='loading')status.hidden=false;},180):null;
    root.dataset.swState = 'loading';
    // Only the first native page's available subsequence is a safe immediate prefix.
    root.dataset.swPage = String(page);
    state.status = 'loading';
    const cards = new Map(); cardsFrom(root, cards);
    let entry = cache.get(key);
    if(!entry) {try {const stored=JSON.parse(sessionStorage.getItem('sw-collection-stock-v2'));if(stored?.key===key)entry=stored.entry;}catch(_) {/* Optional cache. */}}
    if (window.swSquishyCategory?.active(root,url) && entry?.records.some(r=>typeof r.feels!=='string')) entry=null;
    if (!entry || Date.now() - entry.time > 30000) entry = {time:Date.now(), records:[], next:1, pages:1, total:null};
    const assertCurrent = () => { if (token !== run || key !== keyFor(location.href) || !root.isConnected) throw new DOMException('Stale', 'AbortError'); };
    let metadataRequests = 0, cardRequests = 0,cardNetworkTotalMs=0,metadataMs=0,cardWaitMs=0,speculativeCardRequests=0,bootstrapUsed=false;
    const cardPagePromises=new Map(),cardPageControllers=new Map();
    let cardRequestsAborted=0;const speculativePages=[];
    function fetchCardPage(nativePage){
      if(!cardPagePromises.has(nativePage)){
        const u=sourceUrl();u.searchParams.set('page',String(nativePage));u.searchParams.set('section_id',root.dataset.swSection);
        const began=performance.now();cardRequests++;
        const pageController=new AbortController();cardPageControllers.set(nativePage,pageController);
        const promise=get(u,AbortSignal.any([signal,pageController.signal])).then(html=>{cardNetworkTotalMs+=performance.now()-began;return{html};},error=>({error}));
        cardPagePromises.set(nativePage,promise);
      }
      return cardPagePromises.get(nativePage);
    }
    try {
      const metadataStart=performance.now();
      const bootstrapNode=root.querySelector('[data-sw-order-bootstrap]');
      if(bootstrapNode){try{
        const b=JSON.parse(bootstrapNode.textContent);
        if(b.version===1&&String(b.collectionId)===String(ctx.cid)&&b.page===1&&b.offset===0&&page===1&&Number.isInteger(b.total)&&b.total>=0&&b.total<=size&&b.total<=50&&Array.isArray(b.products)&&b.products.length===b.total&&cards.size===b.total){
          const seen=new Set(),records=b.products.map((pair,i)=>{const extra=policy.validateRecord(pair);if(seen.has(pair[0]))throw Error('Duplicate bootstrap');seen.add(pair[0]);const card=cards.get(pair[0]);if(!card||(card.getAttribute(availableAttr)==='true')!==pair[1])throw Error('Bootstrap mismatch');return{...extra,handle:pair[0],available:pair[1],feels:typeof pair[2]==='string'?pair[2]:'',sourcePage:1};});
          entry={time:Date.now(),records,next:2,pages:1,total:b.total};bootstrapUsed=true;
        }
      }catch(_){/* Missing/unknown SSR evidence uses normal validated fetching. */}}
      const nativeSource=root.querySelector('[data-sw-stock-query]');
      const nativeSort=nativeSource?JSON.parse(nativeSource.textContent).sort:null;
      if(!bootstrapUsed&&page===1&&!ctx.explicit&&!ctx.manual&&!feel&&policy.needsMore(entry.records,end,ctx,entry.total!==null&&entry.next>entry.pages,false)&&nativeSort&&nativeSort!==sourceUrl().searchParams.get('sort_by')){
        speculativePages.push(1);
        // Measured All first50 spans two native pages. Bound the overlap to this unfiltered scope only.
        if(String(ctx.cid)==='588426019089'&&size===50&&cards.size===50&&![...url.searchParams.keys()].some(k=>k.startsWith('filter.')))speculativePages.push(2);
        speculativeCardRequests=speculativePages.length;for(const n of speculativePages)void fetchCardPage(n);
      }

      let available = entry.records.filter(r => r.available);
      // At most 100 metadata pages / Shopify's 25,000-record pagination limit.
      while (policy.needsMore(entry.records,end,ctx,entry.total!==null && entry.next>entry.pages,window.swSquishyCategory?.active(root,url)) && entry.next <= entry.pages) {
        if (entry.next > 100) throw Error('Pagination limit');
        const batchEnd = entry.total === null ? entry.next : Math.min(entry.next+2,entry.pages);
        const batch = await Promise.all(Array.from({length:batchEnd-entry.next+1},(_,i)=>entry.next+i).map(async n=>{
          const u = sourceUrl();u.searchParams.set('view','sw-order-data-v2');u.searchParams.set('page',String(n));
          const data=JSON.parse(await get(u,signal));metadataRequests++;return data;
        }));assertCurrent();
        for(const data of batch) {
        if (data.version !== 1 || data.page !== entry.next || !Array.isArray(data.products) || data.total > 25000) throw Error('Invalid metadata');
        if (entry.total !== null && entry.total !== data.total) throw Error('Collection changed');
        const seen = new Set(entry.records.map(r => r.handle));
        for (const [i, pair] of data.products.entries()) {
          if (typeof pair[0] !== 'string' || typeof pair[1] !== 'boolean' || seen.has(pair[0])) throw Error('Invalid collection sequence');
          seen.add(pair[0]); entry.records.push({...policy.validateRecord(pair),handle:pair[0], available:pair[1], feels:typeof pair[2]==='string'?pair[2]:'', sourcePage:Math.floor((data.offset + i)/size)+1});
        }
        entry.pages = data.pages; entry.total = data.total; entry.next++;
        }
        remember(key, entry);
        available = entry.records.filter(r => r.available);
      }
      metadataMs=performance.now()-metadataStart;
      const complete = entry.next > entry.pages;
      if (complete && entry.records.length !== entry.total) throw Error('Incomplete collection');
      const filtered = feel ? entry.records.filter(r => (r.feels || '').split(',').includes(feel)) : entry.records;
      const total = feel ? filtered.length : entry.total;
      if(feel) available=filtered.filter(r=>r.available);
      const ordered = policy.ordered(filtered,ctx,complete);
      const selected = ordered.slice(begin,end);
      // Reuse original native cards; only fetch native pages containing missing visible cards.
      const missingPages = [...new Set(selected.filter(r => !cards.has(r.handle)).map(r => r.sourcePage))];
      for(const n of speculativePages)if(!missingPages.includes(n)){cardPageControllers.get(n)?.abort();cardRequestsAborted++;}
      const cardsWaitStart=performance.now();
      for (let i=0;i<missingPages.length;i+=3) {
        await Promise.all(missingPages.slice(i,i+3).map(async nativePage => {
          const result=await fetchCardPage(nativePage);assertCurrent();if(result.error)throw result.error;
          cardsFrom(new DOMParser().parseFromString(result.html,'text/html'),cards);
        }));
      }
      cardWaitMs=performance.now()-cardsWaitStart;
      assertCurrent();
      for (const record of selected) {
        const card = cards.get(record.handle);
        if (!card || (card.getAttribute(availableAttr)==='true') !== record.available) { cache.delete(key); throw Error('Availability changed'); }
      }
      const fragment = document.createDocumentFragment();
      const promo = [...grid.children].find(n => !n.hasAttribute(attr) && !n.classList.contains('sw-stock-heading') && n.querySelector('img'));
      selected.forEach((record,i) => {
        if(i===1 && promo) fragment.append(promo.cloneNode(true));
        if(!record.available && begin+i===available.length) {
          const divider=document.createElement('div'); divider.className='sw-stock-divider';
          const heading=document.createElement('h2'); heading.textContent='אזלו מהמלאי';divider.append(heading);fragment.append(divider);
        }
        fragment.append(cards.get(record.handle));
      });
      if (entry.total !== 0 || feel) grid.replaceChildren(fragment);
      if(feel && total===0){const empty=document.createElement('p');empty.className='one-whole center';empty.textContent='אין מוצרים שמתאימים לבחירה ולסינון הנוכחיים.';grid.append(empty);}
      if(feel){const summary=root.querySelector('.cc-filters-results__summary');if(summary)summary.textContent=total+' מוצרים';}
      nativePagination?.remove();
      const pages = Math.ceil(total / size);
      if (pages > 1) {
        const nav = document.createElement('nav'); nav.className='pagination large-row sw-stock-paging'; nav.setAttribute('aria-label','עמודי מוצרים');
        const link=(n,text,current=false)=> { const span=document.createElement('span');span.className=current?'page current':'page'; if(current) {span.textContent=text;span.setAttribute('aria-current','page');}else{const a=document.createElement('a');const u=new URL(key);u.searchParams.set('page',String(n));a.href=u.href;a.textContent=text;span.append(a);}nav.append(span);};
        if(page>1) link(page-1,'« הקודם');
        const visible = [...new Set([1,page-1,page,page+1,pages])].filter(n=>n>=1&&n<=pages).sort((a,b)=>a-b);
        let previous=0;visible.forEach(n=>{if(previous&&n-previous>1)nav.append(document.createTextNode(' … '));link(n,String(n),n===page);previous=n;});
        if(page<pages)link(page+1,'הבא »');grid.after(nav);
      }
      root.dataset.swState='ready';window.clearTimeout?.(statusTimer);status.remove();grid.setAttribute('aria-busy','false');
      window.swSquishyCategory?.ready(root,entry.records,feel);
      state.feedSnapshot=policy.makeFeedSnapshot(entry,policy.feedScope(url.href,ctx.cid,size));
      state.status='ready'; state.metrics={page,total,scanned:entry.records.length,complete,availableScanned:available.length,metadataRequests,cardRequests,cardRequestsAborted,speculativeCardRequests,speculativeUsed:speculativePages.some(n=>missingPages.includes(n)),speculativePages,speculativeUsedPages:speculativePages.filter(n=>missingPages.includes(n)),selectedSourcePages:[...new Set(selected.map(r=>r.sourcePage))],bootstrapUsed,metadataMs:Math.round(metadataMs),cardWaitMs:Math.round(cardWaitMs),cardNetworkTotalMs:Math.round(cardNetworkTotalMs),policy:'availability-pin-createdAt-v1',pin:ctx.pin||null,effectiveSort:sourceUrl().searchParams.get('sort_by'),ms:Math.round(performance.now()-startTime)};
      window.updateCartLimitButtons?.();
      document.dispatchEvent(new CustomEvent('sw-stock-ready',{detail:state.metrics}));
      if(window.requestAnimationFrame)window.requestAnimationFrame(()=>window.requestAnimationFrame(()=>{if(token===run){state.metrics.nextRenderingOpportunityMs=Math.round(performance.now()-startTime);document.dispatchEvent(new CustomEvent('sw-order-history-ready'));}}));
    } catch(error) {
      if (error.name === 'AbortError' || token !== run) return;
      window.clearTimeout?.(statusTimer);status.hidden=false;grid.setAttribute('aria-busy','false');state.feedSnapshot=null;
      cache.delete(key);try{sessionStorage.removeItem('sw-collection-stock-v2');}catch(_){}grid.innerHTML=initial;root.dataset.swState='fallback';
      root.querySelector('.sw-stock-paging')?.remove();
      if(!root.querySelector('.pagination')&&originalPaging)grid.insertAdjacentHTML('afterend',originalPaging);
      status.textContent=feel?'לא ניתן להשלים כרגע את הבחירה לפי תחושה. מוצגים המוצרים בסדר הרגיל, ללא סינון לפי תחושה.':'לא ניתן להשלים כרגע את המיון לפי זמינות. מוצג הסדר הרגיל.';
      if(feel){const feelStatus=document.querySelector('[data-sw-feel-status]');if(feelStatus)feelStatus.textContent='הבחירה לא הושלמה. המוצרים מוצגים כרגע ללא סינון לפי תחושה.';}
      const retry=document.createElement('button');retry.type='button';retry.className='btn';retry.textContent='ניסיון נוסף';retry.addEventListener('click',start);status.append(' ',retry);
      state.status='fallback';state.error=String(error);
    }
  }
  document.addEventListener('filters-applied',start);
  if(!history.state?.searchParams)history.replaceState({...history.state,searchParams:location.search.slice(1)},'',location.href);
  // Native Boost owns filter history. Pagination navigation is full-page and preserves
  // every parameter, so reload, direct links and browser back retain the chosen state.
  window.addEventListener('pageshow',e=>{if(e.persisted)start();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


